import store from '@/store'
import SettingsBase from '../components/moduleBase'
import SettingsDashboard from '../views/dashboard/Dashboard'
import Divisions from '../views/Divisions'
import DivisionOverview from '../views/divisionDetail/Overview'
import EmailLog from '../views/EmailLog'

const routes = [
  {
    path: '/settings/',
    component: SettingsBase,
    meta: { appKey: 'settings' },
    beforeEnter: (to, from, next) => {
      store.dispatch('clearSubnav')
      next()
    },
    children: [
      {
        path: 'dashboard',
        component: SettingsDashboard,
        name: 'SettingsDashboard'
      },
      {
        path: 'divisions',
        component: Divisions,
        name: 'Divisions'
      },
      {
        path: 'division-detail/:id',
        component: DivisionOverview,
        name: 'DivisionOverview'
      },
      {
        path: 'email-log',
        component: EmailLog,
        name: 'EmailLog'
      }
    ]
  }
]

export default routes
